(function () {
  const MAX_VISIBLE = 5;
  const GRACE_MS = 150;

  const init = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-card').forEach((card) => {
      card.querySelectorAll('fieldset.h-stack.wrap').forEach((fs) => {
        if (fs.dataset.swatchOverflowDone) return;
        const swatches = fs.querySelectorAll('.color-swatch');
        if (swatches.length <= MAX_VISIBLE) return;
        fs.dataset.swatchOverflowDone = '1';

        const wrapper = document.createElement('span');
        wrapper.className = 'showmore-wrapper';

        const popover = document.createElement('span');
        popover.className = 'showmore-popover';

        let hidden = 0;
        swatches.forEach((sw, i) => {
          if (i < MAX_VISIBLE) return;
          const input = sw.previousElementSibling;
          if (input && input.tagName === 'INPUT') popover.appendChild(input);
          popover.appendChild(sw);
          hidden++;
        });
        if (hidden === 0) return;

        const more = document.createElement('span');
        more.className = 'showmore';
        more.textContent = '+' + hidden;
        more.setAttribute('tabindex', '0');
        more.setAttribute('aria-label', hidden + ' more colors');

        wrapper.appendChild(more);
        wrapper.appendChild(popover);
        fs.appendChild(wrapper);

        let timer;
        const open = () => { clearTimeout(timer); wrapper.classList.add('is-open'); };
        const close = () => { timer = setTimeout(() => wrapper.classList.remove('is-open'), GRACE_MS); };
        wrapper.addEventListener('mouseenter', open);
        wrapper.addEventListener('mouseleave', close);
        wrapper.addEventListener('focusin', open);
        wrapper.addEventListener('focusout', close);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  const obs = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'PRODUCT-CARD' || (n.querySelector && n.querySelector('product-card'))) {
          init(n);
        }
      });
    });
  });
  obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
